import Card from "./components/Card";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { useState, useEffect, useRef } from "react";
import { carouselItems } from "../../../../constants/laboratory/carousel";
import { stats } from "../../../../constants/laboratory/stats";
import { useTranslation } from "../../../../components/Translation";

export default function Carrousel() {
  const [isPlaying, setIsPlaying] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [swiperInstance, setSwiperInstance] = useState<any>(null);
  const paginationRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const togglePlayPause = () => {
    if (swiperInstance) {
      if (isPlaying) {
        swiperInstance.autoplay.stop();
      } else {
        swiperInstance.autoplay.start();
      }
    }
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    if (paginationRef.current) {
      paginationRef.current.classList.remove(
        "swiper-pagination-clickable",
        "swiper-pagination-bullets",
        "swiper-pagination-horizontal"
      );
    }
  }, []);


  return (
    <div className="w-full relative">
      <div className="relative overflow-hidden">
        <Swiper
          className="w-full"
          modules={[Pagination, Navigation, Autoplay]}
          slidesPerView={1}
          spaceBetween={0}
          autoplay={isPlaying ? { delay: 7000, disableOnInteraction: false } : false}
          loop={true}
          centeredSlides={true}
          onSwiper={(swiper) => setSwiperInstance(swiper)}
          pagination={{
            el: ".swiper-pagination",
            clickable: true,
            bulletElement: "button",
            bulletClass: "swiper-pagination-bullet w-2 h-2",
            bulletActiveClass: "swiper-pagination-bullet-active !bg-dorado-uady",
          }}
        >
          {carouselItems.map((item, index) => (
            <SwiperSlide key={index}>
              <Card {...item} />
            </SwiperSlide>
          ))}
          <SwiperNavigation />
        </Swiper>

        {/* Play/pause + bullets — esquina inferior derecha */}
        <div className="absolute bottom-6 right-6 z-20 flex items-center gap-2">
          <div ref={paginationRef} className="swiper-pagination" style={{ position: "relative" }} />
          <button
            onClick={togglePlayPause}
            className="bg-white/20 hover:bg-white/40 backdrop-blur rounded-full p-2 transition"
            aria-label={isPlaying ? "Pausar" : "Reanudar"}
          >
            {isPlaying ? (
              <img src="/img/iconos/pause.png" alt="Pause" className="w-3 h-3" />
            ) : (
              <img src="/img/iconos/play.png" alt="Play" className="w-3 h-3" />
            )}
          </button>
        </div>
      </div>

      {/* Stats strip */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-5xl mx-auto px-6 py-5 grid grid-cols-2 md:grid-cols-4 divide-x divide-gray-200">
          {stats.map((stat, i) => (
            <div key={i} className="px-6 first:pl-0">
              <p className="text-micro text-gray-400 font-semibold uppercase tracking-wider mb-1">
                {t(`laboratorio.${stat.labelKey}`)}
              </p>
              <p className="text-3xl font-bold text-azul-uady">{stat.value}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const SwiperNavigation = () => {
  const swiper = useSwiper();
  return (
    <>
      <button
        onClick={() => swiper.slidePrev()}
        className="absolute top-1/2 left-4 z-10 w-10 h-10 flex items-center justify-center cursor-pointer -translate-y-1/2 bg-white/20 backdrop-blur rounded-full hover:bg-dorado-uady transition"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" className="w-5 h-5">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>
      <button
        onClick={() => swiper.slideNext()}
        className="absolute top-1/2 right-4 z-10 w-10 h-10 flex items-center justify-center cursor-pointer -translate-y-1/2 bg-white/20 backdrop-blur rounded-full hover:bg-dorado-uady transition"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" className="w-5 h-5">
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>
    </>
  );
};